import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';
import Spinner from '../ui/Spinner/Spinner';
import type { ReactNode } from 'react';

/**
 * Route guard for the /dashboard route.
 * Users without the `dashboard_access` permission are redirected
 * to the PermissionBlocked page instead of seeing a blank embed.
 */
export default function DashboardGuard({ children }: { children: ReactNode }) {
  const { isLoading, isSuperAdmin, hasPermission } = usePermissions();

  if (isLoading) {
    return <Spinner overlay text="Checking permissions…" />;
  }

  if (!isSuperAdmin && !hasPermission('dashboard_access')) {
    return (
      <Navigate
        to="/permission-blocked"
        state={{ feature: 'Dashboard', featureKey: 'dashboard_access' }}
        replace
      />
    );
  }

  return <>{children}</>;
}
